type LeaveCheck = () => boolean;

const checks = new Set<LeaveCheck>();

export function registerPendingWorkCheck(check: LeaveCheck): () => void {
  checks.add(check);
  return () => {
    checks.delete(check);
  };
}

export function confirmLeavingPendingWork(): boolean {
  return Array.from(checks).every((check) => check());
}
